module.exports = __webpack_public_path__ + "img/American Express.6c0e1c4a.png";